import FormattedMessage from 'I18n/components/FormattedMessage';
import { ApprovalOperation } from '../../types';
import { UnreachableI18nCaseError } from '../../utils/i18nUtils';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ApprovalOperationI18n(props) {
  const {
    approvalOperation
  } = props;
  switch (approvalOperation) {
    case ApprovalOperation.REQUEST:
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.modal.action.REQUEST"
        });
      }
    case ApprovalOperation.RECALL:
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.modal.action.RECALL"
        });
      }
    case ApprovalOperation.APPROVE:
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.modal.action.APPROVE"
        });
      }
    case ApprovalOperation.REJECT:
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.modal.action.REJECT"
        });
      }
    default:
      throw new UnreachableI18nCaseError(approvalOperation);
  }
}